import React from "react";
import { useTranslation } from "react-i18next";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import DialogTitleWithCloseButton from "../DialogTitleWithCloseButton";

import styles from "./SearchTeamsModal.module.scss";

const SearchTeamsModal = (props) => {
  const {
    open,
    onClickClose,
    onAddToTeam,
    allTeams = [],
    myTeams = [],
  } = props;
  const { t } = useTranslation();

  const [selectedTeam, setSelectedTeam] = React.useState(null);

  return (
    <Dialog
      open={open}
      className={styles.modal}
      onClose={onClickClose}
      fullWidth={true}
      maxWidth={"md"}
    >
      <DialogTitleWithCloseButton
        id="customized-dialog-title"
        onClose={onClickClose}
      >
        {t("search.search_team")}
      </DialogTitleWithCloseButton>
      <DialogContent>
        <div className={styles.container}>
          <div className={styles.search}>
            <Autocomplete
              id="teamSearchInput"
              value={selectedTeam}
              onChange={(event, newValue) => {
                setSelectedTeam(newValue);
              }}
              options={allTeams.sort((a, b) => {
                const label_a =
                  a.first_name + " " + a.last_name + " " + a.email;
                const label_b =
                  b.first_name + " " + b.last_name + " " + b.email;
                return label_a.localeCompare(label_b);
              })}
              groupBy={(team) =>
                team.first_name + " " + team.last_name + " " + team.email
              }
              getOptionLabel={(team) =>
                team.name +
                ",  " +
                team.first_name +
                " " +
                team.last_name +
                " " +
                team.email
              }
              //sx={{ width: 300 }}
              getOptionDisabled={
                (team) => myTeams.some((myTeam) => myTeam.id === team.teamId) //Disabled if already joined
              }
              renderOption={(props, team) => {
                return (
                  <li {...props} key={team.teamId + team.userId}>
                    {team.name /*+ " (" + team.teamId + ")"*/}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField {...params} label="Grouped by users" />
              )}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.button}
          onClick={() => onAddToTeam(selectedTeam.teamId)}
          disabled={selectedTeam === null}
        >
          {t("search.add_to_team")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SearchTeamsModal;
